"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABCIEndpoint = exports.TransactionEndpoint = exports.BlockEndpoint = exports.ConsensusEndpoint = exports.CommonEndpoint = void 0;
var CommonEndpoint;
(function (CommonEndpoint) {
    CommonEndpoint["HEALTH"] = "health";
    CommonEndpoint["STATUS"] = "status";
})(CommonEndpoint || (exports.CommonEndpoint = CommonEndpoint = {}));
var ConsensusEndpoint;
(function (ConsensusEndpoint) {
    ConsensusEndpoint["NET_INFO"] = "net_info";
    ConsensusEndpoint["GENESIS"] = "genesis";
    ConsensusEndpoint["CONSENSUS_PARAMS"] = "consensus_params";
    ConsensusEndpoint["CONSENSUS_STATE"] = "consensus_state";
    ConsensusEndpoint["COMMIT"] = "commit";
    ConsensusEndpoint["VALIDATORS"] = "validators";
})(ConsensusEndpoint || (exports.ConsensusEndpoint = ConsensusEndpoint = {}));
var BlockEndpoint;
(function (BlockEndpoint) {
    BlockEndpoint["BLOCK"] = "block";
    BlockEndpoint["BLOCK_RESULTS"] = "block_results";
    BlockEndpoint["BLOCKCHAIN"] = "blockchain";
})(BlockEndpoint || (exports.BlockEndpoint = BlockEndpoint = {}));
var TransactionEndpoint;
(function (TransactionEndpoint) {
    TransactionEndpoint["NUM_UNCONFIRMED_TXS"] = "num_unconfirmed_txs";
    TransactionEndpoint["UNCONFIRMED_TXS"] = "unconfirmed_txs";
    TransactionEndpoint["BROADCAST_TX_ASYNC"] = "broadcast_tx_async";
    TransactionEndpoint["BROADCAST_TX_SYNC"] = "broadcast_tx_sync";
    TransactionEndpoint["BROADCAST_TX_COMMIT"] = "broadcast_tx_commit";
})(TransactionEndpoint || (exports.TransactionEndpoint = TransactionEndpoint = {}));
var ABCIEndpoint;
(function (ABCIEndpoint) {
    ABCIEndpoint["ABCI_INFO"] = "abci_info";
    ABCIEndpoint["ABCI_QUERY"] = "abci_query";
})(ABCIEndpoint || (exports.ABCIEndpoint = ABCIEndpoint = {}));
